import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import OnboardingPage from "@/pages/OnboardingPage";
import DashboardPage from "@/pages/DashboardPage";
import SurveyPage from "@/pages/SurveyPage";
import ImpactMapPage from "@/pages/ImpactMapPage";
import ActionHubPage from "@/pages/ActionHubPage";

function App() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route path="/dashboard/:companyId" element={<DashboardPage />} />
          <Route path="/survey/:surveyId" element={<SurveyPage />} />
          <Route path="/impact-map/:companyId" element={<ImpactMapPage />} />
          <Route path="/action-hub/:companyId" element={<ActionHubPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: 'hsl(120 10% 4%)',
            border: '1px solid hsl(141 15% 14%)',
            color: 'hsl(138 55% 97%)',
          },
        }}
      />
    </div>
  );
}

export default App;
